import axios from 'axios'

export default {
    get: (id) => axios.get('events-tables/'+id),
    store: (data) => axios.post('events-tables/store', data),
    update: (data) => axios.post('events-tables/update', data),
    delete: (id) => axios.post('events-tables/delete', id)
}